<template>
  <div class="energy-info" v-loading="lockStatus" element-loading-text="数据加载中......" element-loading-spinner="el-icon-loading">
    <el-row class="top-box" :gutter="5">
      <el-col :xs="8" :md="8">
        <corner-box>
          <div class="box-element">
            <div class="box-title">项目概况——{{selectFactory.divisionName}}</div>
            <el-select class="fr" v-model="selectFactory" value-key="divisionName" placeholder="请选择" @change="changeFactory()">
              <el-option v-for="item in factoryOptions" :key="item.id" :label="item.divisionName" :value="item"></el-option>
            </el-select>
            <ul class="icon-list">
              <li class="icon-item fl" v-for="item in introduce" :key="item.title">
                <div class="icon-box iconfont" v-html="item.icon"></div>
                <p class="item-title">{{ item.title }}</p>
                <h4 class="item-num">{{ item.num }}{{ item.unit }}</h4>
              </li>
            </ul>
          </div>
        </corner-box>
      </el-col>
      <el-col :xs="8" :md="8">
        <corner-box>
          <div class="box-element">
            <div class="box-title">分类用能概况</div>
            <el-date-picker class="date-select fr" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :clearable='false' v-model="dateTo" @change="changeDate(dateTo)" :picker-options="pickerOptions">
            </el-date-picker>
            <el-table class="energy-table noBackground hasBorder headerNoBc" :data="tableData">
              <el-table-column prop="type" label="分类"> </el-table-column>
              <el-table-column prop="month" label="当月能耗"> </el-table-column>
              <el-table-column prop="year" label="当年能耗"> </el-table-column>
              <el-table-column prop="unit" label="单位"> </el-table-column>
            </el-table>
          </div>
        </corner-box>
      </el-col>
      <el-col :xs="8" :md="8">
        <corner-box>
          <div class="box-element">
            <div class="box-title">分类用能占比</div>
            <div class="tool fr">
              <el-button @click="download({title: '分类用能占比' ,selector:'#pieChart'})">下载</el-button>
              <el-button @click="print({title: '分类用能占比' ,selector:'#pieChart'})">打印</el-button>
            </div>
            <div class="note"><span>*</span>该占比统一为<span class="imp">标准煤</span>转换计算</div>
            <div class="pie-chart" id="pieChart" :style="{width: '100%', height: '76%'}"></div>
          </div>
        </corner-box>
      </el-col>
    </el-row>
    <el-row class="bottom-box top-box">
      <el-col :xs="24" :md="24">
        <corner-box>
          <div class="box-element">
            <div class="box-title">能耗曲线</div>
            <div class="tool fr">
              <el-button @click="download({title: '能耗曲线' ,selector:'#lineChart'})">下载</el-button>
              <el-button @click="print({title: '能耗曲线' ,selector:'#lineChart'})">打印</el-button>
            </div>
            <ul class="energy-list">
              <li class="energy-item fl" v-for="item in kinds" :key="item.name" @click="selectEnergy(item)">
                <i class="iconfont" v-html="item.icon" :class="{ active: item.selected }"></i>
                <span>{{ item.name }}</span>
              </li>
            </ul>
            <div class="energy-unit">({{ energyUnit }})</div>
            <div class="line-chart" id="lineChart" :style="{width: '100%', height: '80%'}"></div>
          </div>
        </corner-box>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import cornerBox from "../../components/cornerBox";
import {getNowFormatDate} from "../../assets/js/tools/time.js"
var echarts = require('echarts');
import {addResize,removeResize} from "../../assets/js/tools/echartsResize"
export default {
  name: "energyConsumptionProfile",
  data() {
    return {
      selectFactory: {"id": "1","divisionName": "北自园区"},
      factoryName: "",
      dateTo: "",
      factoryOptions: [{"id": "1","divisionName": "北自园区"}],
      tableData: [],
      currentEnergy: "elec",
      energyUnit: "kW·h",
      lockStatus: "",
      lineData: "",
      pieChart: "",
      lineChart: "",
      introduce: [{
          icon: "&#xe635;",
          title: "建筑数量",
          num: "0",
          unit: "个",
        },{
          icon: "&#xe605;",
          title: "建筑面积",
          num: "0",
          unit: "平方米",
        },{
          icon: "&#xe638;",
          title: "配电室数量",
          num: "0",
          unit: "个",
        },{
          icon: "&#xe637;",
          title: "水泵房数量",
          num: "0",
          unit: "个",
        },{
          icon: "&#xe636;",
          title: "燃气调压站",
          num: "0",
          unit: "个",
        },{
          icon: "&#xec4d;",
          title: "电表数量",
          num: "0",
          unit: "个",
        },{
          icon: "&#xec67;",
          title: "水表数量",
          num: "0",
          unit: "个",
        },{
          icon: "&#xeca4;",
          title: "燃气表数量",
          num: "0",
          unit: "个",
        }],
      kinds: [{
          icon: "&#xe61a;",
          name: "电",
          selected: true,
          value: "elec",
          unit: "kW·h"
        },{
          icon: "&#xe60c;",
          name: "水",
          selected: false,
          value: "water",
          unit: "t"
        },{
          icon: "&#xe617;",
          name: "气",
          selected: false,
          value: "gas",
          unit: "m³"
        },{
          icon: "&#xe618;",
          name: "光伏",
          selected: false,
          value: "pv",
          unit: "v"
        }],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  components: {
    cornerBox
  },
  beforeDestroy(){
    removeResize(this.pieChart)
    removeResize(this.lineChart)
  },
  mounted() {
    this.defaultDate();
    this.getData(this.currentEnergy);
  },
  methods: {
    changeDate() {
      this.lockStatus = true;
      this.getData(this.currentEnergy);
    },
    defaultDate() {
      this.dateTo = getNowFormatDate();
    },
    changeFactory() {
      this.lockStatus = true;
      this.getData();
    },
    selectEnergy(item) {
      this.kinds.forEach(function (i) {
        i.selected = false;
      });
      item.selected = true;
      this.currentEnergy = item.value;
      this.energyUnit = item.unit;
      this.fillLineChart();
    },
    postData() {
      let params = {};
      params.$divisionId = this.selectFactory.id;
      params.$frontEndUrl = "energyConsumptionProfile";
      params.$endDate = this.dateTo;
      return params;
    },
    getData() {
      let $this = this;
      this.$get("energyconsumptionprofile/energyoverview", this.postData()).then(
        (response) => {
          this.lockStatus = false;
          $this.factoryOptions = response.divisionList;
          $this.introduce[0].num = response.projectInfo.buildingNum;
          $this.introduce[1].num = response.projectInfo.buildingAcreage;
          $this.introduce[2].num = response.projectInfo.transformerroomNum;
          $this.introduce[3].num = response.projectInfo.pumpHouseNum;
          $this.introduce[4].num = response.projectInfo.GasStationNum;
          $this.introduce[5].num = response.projectInfo.elecMeterNum;
          $this.introduce[6].num = response.projectInfo.waterMeterNum;
          $this.introduce[7].num = response.projectInfo.gasMeterNum;
          $this.tableData = this.fillTable(response.table);
          $this.fillPieChart(response.percentage);
          $this.lineData = response.lineChart;
          $this.fillLineChart();
        },
        (err) => {
          console.log(err);
          this.lockStatus = false;
        }
      );
    },
    fillTable(list) {
      this.table = [];
      for (let key in list) {
        var element = {};
        if (key !== "title") {
          element.type = list[key][0];
          element.month = list[key][1];
          element.year = list[key][2];
          element.unit = list[key][3];
          this.table.push(element);
        }
      }
      return this.table;
    },
    fillPieChart(data) {
      this.pieChart = echarts.init(document.getElementById("pieChart"));
      this.pieChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        color: ["#ef7184", "#db96fb", "#84cbfc"],
        series: [
          {
            type: "pie",
            radius: ["50%", "60%"],
            avoidLabelOverlap: true,
            label: {
              position: "outer",
              formatter: "{b}：{d}%",
            },
            labelLine: {
              show: true,
            },
            data: [ { name: "电", value:data.elec},
              { name: "气", value:data.gaster},
              { name: "水", value:data.water}
            ]
          }
        ],
      });
      addResize(this.pieChart);
    },
    fillLineChart() {
      this.lineChart = echarts.init(document.getElementById("lineChart"));
      let yestData = [];
      let nowData = [];
      if( this.lineData.hasOwnProperty(this.currentEnergy) ) {
        yestData = this.lineData[this.currentEnergy].before;
        nowData = this.lineData[this.currentEnergy].current;
      }
      let xData = ["0h","1h","2h","3h","4h","5h","6h","7h","8h","9h","10h","11h","12h","13h","14h","15h","16h","17h","18h","19h","20h","21h","22h","23h"];
      this.lineChart.setOption({
        legend: {
          icon: "circle",
          textStyle: {
            color: "#fff",
          },
          right: "200",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xData,
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        grid: {
          left: 55,
          top: 50,
          right: 30,
          bottom: 40,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#ccc",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#082E44",
            },
          },
        },
        series: [
          {
            name: "昨日",
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            data: yestData,
            itemStyle: {
              normal: {
                color: "#ef7184",
              },
            },
          },
          {
            name: "当日",
            type: "line",
            symbolSize: 8,
            symbol: "circle",
            data: nowData,
            itemStyle: {
              normal: {
                color: "#39DCDE",
              },
            },
          },
        ],
      });
      addResize(this.lineChart);
    },
    print(option) {
      this.printHtml({'htmlTitle': option.title, 'selector': option.selector, 'type': 'canvas'});
    },
    download(option) {
      this.getPdf({'htmlTitle': option.title, 'selector': option.selector});
    },
  },
};
</script>
<style scoped lang="scss">
.energy-info {
  padding-bottom: 20px;
  .top-box {
    padding: 5px;
    .box-element {
      border: 1px solid #083550;
      //background: linear-gradient(
      //  0deg,
      //  rgba(4, 72, 120, 0),
      //  rgba(4, 72, 120, 0.4)
      //);
      height: 315px;
      overflow: hidden;
      .box-title {
        position: relative;
        margin: 3px 3px;
        height: 33px;
        font-size: 14px;
        line-height: 33px;
        text-align: center;
        color: #fff;
        background: #097dc6;
       /* &::before {
          content: "";
          display: inline-block;
          width: 4px;
          height: 14px;
          background: #ff2100;
          border-radius: 0 5px 5px 0;
          position: absolute;
          left: 0;
          top: 9px;
        }*/
      }
      .el-select,
      .date-select,
      .tool {
        margin-right: 4px;
        margin-top: 8px;
      }
      .date-select {
        width: 150px;
      }
      .icon-list {
        padding-top: 20px;
        width: 100%;
        padding-left: 0;
        margin: 0;
        overflow: hidden;
        .icon-item {
          height: 105px;
          width: 25%;
          color: #fff;
          font-size: 14px;
          .icon-box {
            margin: 0 auto;
            font-size: 37px;
            text-align: center;
            background: linear-gradient(to bottom, #2666f9, #5a27e0);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
          }
          .item-title {
            margin: 5px 0;
            text-align: center;
          }
          .item-num {
            margin: 0;
            font-weight: 300;
            text-align: center;
          }
        }
      }
      .energy-table {
        height: 220px;
        margin-top: 55px;
        background-color: inherit;
      }
      .note {
        margin-left: 23px;
        margin-top: 8px;
        color: #999;
        span {
          color: #fd6d90;
        }
        .imp {
          color: #1384c5;
        }
      }
      .pie-chart {
        height: 240px;
        margin-top: 20px;
      }
    }
  }
  .bottom-box {
    padding-top: 0px;
    .box-element {
      height: 450px;
      position: relative;
      .box-title {
        width: 99.7%;
      }
      .energy-list {
        margin-top: 22px;
        margin-left: 41%;
        padding: 0;
        height: 30px;
        li {
          cursor: pointer;
          i {
            font-size: 30px;
            color: #1384C5;
            margin-right: 10px;
            vertical-align: middle;
          }
          .active {
            color: #3deee7;
            box-shadow: inset 0 0 4px #3deee7;
          }
          span {
            margin-right: 25px;
            font-size: 12px;
            color: #fff;
          }
        }
      }
      .energy-unit {
        position: absolute;
        left: 8px;
        font-size: 14px;
        color: #fff;
      }
      .line-chart {
        height: 350px;
      }
    }
  }
  @media screen and (width:3440px) and (height: 1440px )   {
    .bottom-box{
      .box-element{
        height: 700px;
      } 
    }
      
    }
}
</style>
